export const TREADWELL_AI_MESSAGE_CHANGE_MS = 5000;

export const TREADWELL_AI_LOADING_MESSAGES = [
  [
    'Gathering tire test results for {{city}} drivers',
    'Checking how these tires performed at our Treadwell test track',
    'Starting your personalized tire search',
    'Reviewing real-world results for {{city}} roads',
    'Cross-checking tire wear patterns for {{city}} roads',
    'Reviewing how tires perform in {{city}} temperatures'
  ],
  [
    'Pulling data from thousands of tire tests',
    'Looking at traction and grip scores for your area',
    'Thinking about the best tire fit for your needs',
    'Matching tires to your daily driving habits',
    'Looking at tread life for long-lasting performance',
    'Looking at how tires handle sharp turns and quick stops',
    'Checking stopping distance in real-world conditions'
  ],
  [
    'Comparing tires for smooth rides in city traffic',
    'Checking performance for your car and driving style',
    'Reviewing braking and handling in dry and wet conditions',
    'Comparing comfort and noise ratings from our tests',
    'Checking fuel-saving features for your vehicle',
    'Reviewing safety scores for peace of mind',
    'Finalizing the best match for your car'
  ]
];
